import React, { useCallback, useImperativeHandle, useState } from 'react';
import { FeedbackQuestionHandler, FeedbackSectionInfo } from '../utils';
import ReportCustomQuestionType from '../../../ReportBuilder/Components/Review/ReportCustomQuestionType';
import {
  CustomQuestionAnswer,
  CustomSingleQuestion,
} from 'admin/pages/ManageAccounts/CustomQuestions/utilts';
import TrueImpactLoading from 'shared/components/TrueImpactLoading';
import { getCustomQuestionId } from 'donor/portal/pages/FeedbackDashboard/Feedback/api';

const CustomQuestionSection = React.forwardRef<
  FeedbackQuestionHandler,
  FeedbackSectionInfo
>(
  (
    { reportId, questionId, customQuestionsById, handleCompleted },
    forwardRef,
  ) => {
    const [done, setDone] = useState<boolean>(false);
    const c = customQuestionsById[getCustomQuestionId(questionId)];
    const [customQuestion, setCustomQuestion] = useState<CustomSingleQuestion>(
      c?.question,
    );

    useImperativeHandle(forwardRef, () => ({
      reportId,
      questionId: Number(getCustomQuestionId(questionId)),
      answer: () => (done ? 'done' : ''),
      errorText: () =>
        done ? undefined : 'Please save the answer when you are done.',
    }));

    const handleChange = useCallback(
      (
        customQuestionIndex: number,
        questionIndex: number,
        questionId: number | string,
        answer: CustomQuestionAnswer,
      ) => {
        setCustomQuestion(s => {
          const newState = { ...s };
          const a = {
            dbId: answer.dbId,
            optionId: answer.optionId,
            value: answer.value,
          };
          if (newState.answer) {
            newState.answer = [...newState.answer];
            newState.answer[0] = a;
          } else {
            newState.answer = [a];
          }
          return newState;
        });
      },
      [setCustomQuestion],
    );

    const handleDone = useCallback(() => {
      setDone(true);
      handleCompleted();
    }, [setDone, handleCompleted]);
    const handleUnDone = useCallback(() => {
      setDone(false);
    }, [setDone]);

    if (!customQuestion) {
      return <TrueImpactLoading />;
    }

    return (
      <ReportCustomQuestionType
        reportId={reportId}
        saveButtonText="Save and Done"
        answer={customQuestion.answer}
        onChange={handleChange}
        customQuestionIndex={c.surveyIndex}
        customQuestion={c.survey}
        questionIndex={c.questionIndex}
        question={customQuestion}
        handleAddDoneQuestionId={handleDone}
        handleRemoveDoneQuestionId={handleUnDone}
      />
    );
  },
);

export default CustomQuestionSection;
